var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col span-12"},[_c('KeyValue',{attrs:{"mode":_vm.mode,"as-map":true},on:{"input":function($event){return _vm.$emit('input', _vm.value)}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }